@if (Open) {
  <mj-slide-panel Mode="dialog" [Title]="''" [Visible]="true" [WidthPx]="520" (Closed)="Finish()">
    <!-- markup.html:952-967 -->
    <div dialog-content class="oep-tour" role="dialog" aria-modal="true" aria-labelledby="oep-tour-title" tabindex="-1" (keydown)="TrapTab($event)">
      <div class="oep-tour__head">
        <div class="oep-tour__step">{{ StepLabel }}</div>
        <h2 id="oep-tour-title" class="oep-tour__title">{{ Current.Title }}</h2>
      </div>
      <div class="oep-tour__body">
        <p class="oep-tour__text" aria-live="polite">{{ Current.Body }}</p>
        <div class="oep-tour__dots" aria-hidden="true">
          @for (s of Steps; track $index) { <span class="oep-tour__dot" [class.oep-tour__dot--on]="$index === Step"></span> }
        </div>
        <div class="oep-tour__actions">
          <button #NextButton type="button" mjButton variant="primary" class="oep-tour__next" (click)="Next()">{{ NextLabel }}</button>
          <button type="button" class="oep-tour__skip" (click)="Finish()">Skip</button>
        </div>
      </div>
    </div>
  </mj-slide-panel>
}
